module.exports = __webpack_public_path__ + "media/os-iot.89870178.mp4";